import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { format, parseISO } from 'date-fns';

const StyledBox = styled(Box)(({theme}) => ({
}));


export default function WorkOrderDate({prefix, isoDateString, boldDate=false, dateFormat='d MMMM yyyy', ...props}) {
    if (!isoDateString) {
        return null
    }
    const dateObject = parseISO(isoDateString)
    if (!dateObject) {
        return isoDateString
    }
    const formattedDateString = format(dateObject, dateFormat)
    return (
        <StyledBox component='span' {...props}>
            {prefix || ''}
            { boldDate ? <strong>{formattedDateString}</strong> : formattedDateString }
        </StyledBox>
    )
}